import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class UpdateInventory extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Update Store Inventory</h1>
				<p>This method updates properties of the specified inventory.</p>
				<h4>Request</h4>
				<table>
					<tbody>
						<tr>
							<th>Method </th>
							<th>URI </th>
						</tr>
						<tr>
							<td> PUT </td>
							<td> {`/inventories/{inventory_id}`}</td>
						</tr>
					</tbody>
				</table>
				<h4>Parameters</h4>
				<table>
					<tbody>
						<tr>
							<th>Parameter Name </th>
							<th>Value </th>
							<th>Optional </th>
							<th>Description </th>
						</tr>
						<tr>
							<td> inventory_id </td>
							<td> Integer </td>
							<td> </td>
							<td> The ID of the inventory to update </td>
						</tr>
					</tbody>
				</table>
				<h4>Request body</h4>
				<p>In the request body, supply a <a href="?page=resource-representations-inventory">store inventory resource</a>. The store inventory resource should include:</p>
				<ul>
					<li>quantity (has to have a + (plus) or - (minus) sign in front of it. You can only add or subtract quantity, not set it to a new value because quantity can change when buyers submit orders in your store.)</li>
					<li>unit_price</li>
					<li>description</li>
					<li>remarks</li>
					<li>bulk</li>
					<li>is_retain</li>
					<li>is_stock_room</li>
					<li>stock_room_id (only when is_sock_room is "true")</li>
					<li>my_cost</li>
					<li>sale_rate</li>
					<li>tier_quantity1</li>
					<li>tier_price1</li>
					<li>tier_quantity2</li>
					<li>tier_price2</li>
					<li>tier_quantity3</li>
					<li>tier_price3</li>
				</ul>
				<p>Note that to set tier price options, all 6 values must be entered</p>
				<h4>Response</h4>
				<p>If successful, this method returns a <a href="?page=resource-representations-inventory">store inventory resource</a> as "data" in the response body.</p>
				<h4>Example</h4>
				<ul>
					<li>
						PUT /inventories/1234
						<ul>
							<li>Updates inventory #1234</li>
						</ul>
					</li>
				</ul>
			</section>
		);
	}
}